// 品类管理模块
export default [
  {
    path: '/categoryManager/primaryCategory',
    name: 'primaryCategory',
    component: () => import('@/views/categoryManager/primaryCategory.vue'),
    meta: { title: '产品品类' }
  },
  {
    path: '/categoryManager/primaryCategoryDetail',
    name: 'hasParent/categoryManager/primaryCategory',
    component: () => import('@/views/categoryManager/primaryCategoryDetail.vue'),
    meta: { title: '产品子类' }
  },
  {
    path: '/categoryManager/categoryEditPage',
    name: 'hasParent/categoryManager/primaryCategory',
    component: () => import('@/views/categoryManager/categoryEditPage.vue'),
    meta: { title: '子类详情编辑页' }
  },
  {
    path: '/categoryManager/brandManagerment',
    name: 'brandManagerment',
    component: () => import('@/views/categoryManager/brandManagerment.vue'),
    meta: { title: '品牌管理' }
  },
  {
    path: '/categoryManager/groupLabelManagerment',
    name: 'groupLabelManagerment',
    component: () => import('@/views/categoryManager/groupLabelManagerment.vue'),
    meta: { title: '分组标签管理' }
  },
  {
    path: '/categoryManager/appGuide',
    name: 'appGuide',
    component: () => import('@/views/categoryManager/appGuide.vue'),
    meta: { title: '引导页管理' }
  },
  {
    path: '/categoryManager/addAppGuide',
    name: 'hasParent/categoryManager/appGuide',
    component: () => import('@/views/categoryManager/addAppGuide.vue'),
    meta: { title: '添加App引导页面' }
  },
  {
    path: '/categoryManager/appCategory/index',
    name: 'appCategoryIndex',
    component: () => import('@/views/categoryManager/appCategory/index.vue'),
    meta: { title: 'APP品类管理' }
  },
  {
    path: '/categoryManager/appCategory/edit',
    name: 'appCategoryEdit',
    component: () => import('@/views/categoryManager/appCategory/edit.vue'),
    meta: { title: '编辑APP品类' }
  }
]
